import api from "./api.service";

class DocumentsService {
  static deleteDocument = (data: any) => {
    return api.delete('documents/file/deleteCv', { data });
  }
}

export default DocumentsService;
